package com.xtream.data_kmp.db.repo

import com.xtream.data_kmp.AppConfig
import com.xtream.data_kmp.WatchedLiveStreams
import com.xtream.data_kmp.db.AppRoomDB


class WatchedLiveRepository (
    val db: AppRoomDB,
){
    fun getWatchedStreamFlow( streamId:Int?)=db.watchedLiveDao().getSingleFlow(streamId)
     suspend fun insert(  watchedLiveStreams: WatchedLiveStreams){
        db.watchedLiveDao().insert(watchedLiveStreams)
        db.watchedLiveDao().deleteByOffset(AppConfig.WATCHED_LIST_LIMIT,-1)
    }
    fun getSizeAsFlow() =db.watchedLiveDao().getSizeAsFlow()

    suspend fun deleteAll() = db.watchedLiveDao().delete()
}